/**
 * Antdesign Pagination 组件
 * 多语言
 */
import React, { Component } from 'react';
import { Pagination, ConfigProvider } from 'antd';
import { store } from 'Store/store.index';
import { LANG_CHANGE } from 'Store/constants';
import en_US from 'antd/es/locale/en_US';
import es_ES from 'antd/es/locale/es_ES';
import de_DE from 'antd/es/locale/de_DE';
import fr_FR from 'antd/es/locale/fr_FR';
import it_IT from 'antd/es/locale/it_IT';
import nl_NL from 'antd/es/locale/nl_NL';
import ja_JP from 'antd/es/locale/ja_JP';
import ko_KR from 'antd/es/locale/ko_KR';
import zh_CN from 'antd/es/locale/zh_CN';

class ConfigPagination extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: en_US
        };
    }
    componentDidMount () {
        this.changeLanguage();
        store.appStore.addAppEventListener(LANG_CHANGE, () => {
            this.changeLanguage();
        });
    }
    componentWillUnmount () {
        this.setState = () => false;
    }
    changeLanguage () {
        const lng = store.appStore.lng;
        let lang;
        switch (lng.full) {
            case 'en-US': 
                lang = en_US;
                break;
            case 'es-419': 
                lang = es_ES;
                break;
            case 'de-DE': 
                lang = de_DE;
                break;
            case 'fr-FR': 
                lang = fr_FR;
                break;
            case 'it-IT': 
                lang = it_IT;
                break;
            case 'nl-NL': 
                lang = nl_NL;
                break;
            case 'ja-JP': 
                lang = ja_JP;
                break;
            case 'ko-KR': 
                lang = ko_KR;
                break;
            case 'zh-CN': 
                lang = zh_CN;
                break;
            default: 
                lang = en_US;
                break;
        }
        this.setState({ lang });
    }
    render () {
        const { lang } = this.state;
        return (
            <ConfigProvider locale={lang}>
                <Pagination {...this.props}></Pagination>
            </ConfigProvider >
        );
    }
}
export default ConfigPagination;
